export const BRAND_ASSET_VERSION = process.env.NEXT_PUBLIC_BRAND_ASSET_VERSION?.trim() || "20260223-2";

export const BRAND_LOGO_PATH = `/logo.png?v=${BRAND_ASSET_VERSION}`;
export const BRAND_MARK_PATH = `/web-app-manifest-192x192.png?v=${BRAND_ASSET_VERSION}`;
export const BRAND_LOGO_URL = `https://zipvibe.app/logo.png?v=${BRAND_ASSET_VERSION}`;
